<div class="review-actions">
  @if (authService.hasPermission(Permission.PostAssetsPreRelease) || assetType !== 'post-asset') {
    <div
      class="review-actions__header"
      >
      {{ assetType === 'shoot-asset' ? '' : currentChannel + ' ' }}STATUS
    </div>
  }
  <div
    class="review-actions__btn"
    [ngClass]="{
      disabled: disabled,
      'no-head': !authService.hasPermission(Permission.PostAssetsPreRelease) && assetType === 'post-asset'
    }"
    >
    @if (assetState !== eState.IN_REVIEW) {
      <button
        [disabled]="disabled"
      [ngClass]="{
        approved: assetState === eState.APPROVED,
        rejected: assetState === eState.REJECTED
      }"
        class="review-actions__action-state"
        mat-stroked-button
        color="success"
        disabled
        >
        {{ textMapping[assetState] }}
      </button>
    }
    @if (assetState === eState.IN_REVIEW) {
      <button
        [disabled]="disabled || !hasReviewPermission"
        class="review-actions__action-approve"
        mat-stroked-button
        color="success"
        (click)="onReview(eState.APPROVED)"
        >
        Approve
      </button>
    }
    @if (assetState === eState.IN_REVIEW) {
      <button
        [disabled]="disabled || !hasReviewPermission"
        class="review-actions__action-reject"
        mat-stroked-button
        color="error"
        (click)="checkReject()"
        >
        Reject
      </button>
    }
    @if (assetState !== eState.IN_REVIEW) {
      <button
        [disabled]="disabled || !hasReviewPermission"
        class="review-actions__action-clear"
        mat-stroked-button
        color="primary"
        (click)="onReview(null)"
        >
        Clear
      </button>
    }
  </div>
</div>
